module.exports = __webpack_public_path__ + "img/close.a894e954.svg";